/**
 * @generated SignedSource<<5fbd53f88dd38c257494e2bd7e266662>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserContentSubmissionDialog_UserFragment$data = {
  readonly extension: {
    readonly firstName?: string | null | undefined;
    readonly lastName?: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "UserContentSubmissionDialog_UserFragment";
};
export type UserContentSubmissionDialog_UserFragment$key = {
  readonly " $data"?: UserContentSubmissionDialog_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserContentSubmissionDialog_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserContentSubmissionDialog_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "InfectopharmUserExtension"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            }
          ],
          "type": "InfectopharmUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1395b000947425ce1419a772ae3de9f3";

export default node;
